<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :onClose="onClose">




        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
            <h2 style="margin-bottom: 16px; font-size: 22px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                <span style="color: #f00;">WARNING!</span><br/>You will lose your<br/>70% discount!
            </h2>
            <div style="text-align: center;">
                <img style="width: 46px; height: 46px; margin: 7px 10px 0 0;" alt="DentiCalc" src="/images/dc_4in1_150_150.png">
                <br/>
                <span style="font-size: 22px;">
                    DentiCalc PREMIUM
                </span>
            </div>
            <br/>
            <pm-premium-features-list />

            <span style="font-weight: 600;">Use your discount now!</span>
            <br/>
            <strike style="font-size: 18px; display: inline-block; margin-right: 10px; font-weight: 600;">{{ origPrice }}</strike> <span style="font-weight: 600;">{{introPrice}}/month</span>
            <pm-iap-product-button :sku="selectedSku" overrideTitle="CONTINUE" style="margin: 20px auto 16px auto;" />
            <small>No risk, cancel anytime in the Store</small>
        </p>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import PmIapProductButton from "@/components/core/iap-product-button.vue";
import PmPremiumFeaturesList  from "./premium-features-list.vue";
import PmPrivacyLinks from "../addons/privacy-links";
export default {
    components: {
        PmCustomDialog,
        PmIapProductButton,
        PmPrivacyLinks,
        PmPremiumFeaturesList
    },
    data: () => ({
        visible: false,
        selectedSku: window.IAP.getDefaultSku(),
    }),
    created() {
        this.registerBusEvent('subscribe:process', this.changeProcessStatus);
    },
    computed: {
        origPrice() {
            const product = IAP.getProduct(this.selectedSku);
            return IAP.getProductPrices(product);
        },
        introPrice() {
            const product = IAP.getProduct(this.selectedSku);
            return IAP.getIntroPrice(product);
        },
    },
    methods: {
        changeProcessStatus(data) {
            this.visible = Boolean(data);
        },
        show() {
            this.visible = true;
            this.logDialogView();
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        logDialogView() {
            const interestedToUpgrade = parseInt(localStorage.getItem('interestedToUpgrade') || '0', 10) + 1;

            localStorage.setItem('interestedToUpgrade', String(interestedToUpgrade));

            window.Tracker.logEvent({
                event_label: 'interestedToUpgrade',
                event_name: 'interested_to_upgrade',
                event_value: interestedToUpgrade,
            });
        },
        async gotoSubscriptionsAndRestorePurchases() {
            const params = {task: 'restore_purchases'};

            try {
                await this.goToRoute('addons', params);
            } catch (error) {
                captureException(error);
            }
        },

        onClose() {
            // this.$bus.$emit('openAppDialog','extraTrialOffer');
        },

        async goToRoute(routeName, params = null) {
            this.close();
            await this.$router.push({name: routeName, params});
        },
    }
}
</script>
